import styled from '@emotion/styled/macro';

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const TitleContainer = styled.div`
  padding-left: 50px;
`;

export const MenuContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  height: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const VerticalDivider = styled.div`
  height: 100%;
  width: 1px;
  border-radius: 5px;
  background-color: #f0f0f7;
`;

export const DropDownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  margin-top: 10px;
  & button {
    background-color: #f9f9f9;
    border: none;
    color: black;
    text-align: start;
    width: 100%;
    padding: 8px 12px;
    display: block;
    :hover {
      cursor: pointer;
      background-color: #bcbccb;
    }
  }
`;

export const ProfileContainer = styled.div`
  display: flex;
  position: relative;
  gap: 5px;
  align-items: center;
  padding-right: 15px;
  :hover ${DropDownContent} {
    display: block;
  }
`;

export const DropDown = styled.div`
  position: relative;
  margin: 10px;
`;

export const ProfileImage = styled.div`
  background-image: url(${(props) => props.profileImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 10px;
  border-radius: 100px;
  width: 20px;
  height: 20px;
`;
